module.exports = __webpack_public_path__ + "img/transphone.b001b28d.png";